/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BaseApiService } from './baseApiService';
import { ExemptPeriod } from '../models';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ExemptPeriodService extends BaseApiService<ExemptPeriod> {
  get cacheKey(): StorageKey {
    return StorageKey.exemptPeriodServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.apiUrl}/exemptPeriods`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  protected parse(obj) {
    return ExemptPeriod.parse(obj);
  }

  protected unparse(obj) {
    return ExemptPeriod.unparse(obj);
  }

  listExemptPeriodByYearAndMonth(contractId: string, period: {start: string; end: string}) {
    return this.list({
      contractId,
      ['startsAt[lte]']: `${period.end}T23:59:00.000Z`,
      ['endsAt[gte]']: `${period.start}T00:00:00.000Z`
    });
  }
}
